/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ table: NonNullable<unknown> }} Datasets_Import_Csv_Title_AppendInputs */



/**
* | output |
* | --- |
* | "Import CSV into {table}" |
*
* @param {Datasets_Import_Csv_Title_AppendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_title_append = /** @type {((inputs: Datasets_Import_Csv_Title_AppendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Title_AppendInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`CSV in ${i?.table} importieren`)
	return /** @type {LocalizedString} */ (`Import CSV into ${i?.table}`)
});